import { NavLink } from 'react-router';

import type { LinkProps as BumblebeeLinkProps } from '@shieldpay/bumblebee/link';
import { Link as BumblebeeLink } from '@shieldpay/bumblebee/link';

import type { RemoveNavLinkProperty } from '../../utilities/remove-navlink-property';

export const Link = ({
  ...props
}: RemoveNavLinkProperty<BumblebeeLinkProps>) => {
  // @ts-expect-error Fix later either with types or another approach
  return <BumblebeeLink {...props} NavLink={NavLink} />;
};
